import {configureStore, isRejected, Middleware, MiddlewareAPI} from '@reduxjs/toolkit';
import configLayerReducer from './slices/GeomonitoringSlice';
import keycloakReducer from './slices/KeycloakSlice';
import elementChangesReducer from './slices/ElementChangesSlice';
import oldDesignReducer from './slices/ChartStateSlice';
import {setupListeners} from '@reduxjs/toolkit/query';
import {showMessageOnError} from '@dmt/global_npm';
import {drillholeApi} from "./rtk/drillholeApi";
import {settingsApi} from "./rtk/settingsApi";
import projectReducer from './slices/ProjectSlice';

export const rtkQueryErrorLogger: Middleware =
    (api: MiddlewareAPI) => (next) => (action: any) => {
        if (isRejected(action)) {
            switch (action.payload?.status) {
                case 400:
                case 401:
                case 403:
                    showMessageOnError('Error', JSON.stringify(action.payload.data));
                    break;
            }
        }

        return next(action);
    };

const store: any = configureStore({
        reducer: {
            'configLayer': configLayerReducer,
            'keycloakData': keycloakReducer,
            'elementChangesData': elementChangesReducer,
            'oldDesignState': oldDesignReducer,
            'project': projectReducer,
            [drillholeApi.reducerPath]: drillholeApi.reducer,
            [settingsApi.reducerPath]: settingsApi.reducer,
        },
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware().concat(
                drillholeApi.middleware,
                settingsApi.middleware,
                rtkQueryErrorLogger),
    }
);

setupListeners(store.dispatch);
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store;
